export default __webpack_public_path__ + "static/media/duration.3b974cf9.svg";